/* rp-ritual.js — Repose "The Ritual" page
 *
 * Two jobs, no libraries:
 *   1. fade elements up as they enter the viewport
 *   2. animate the <details> disclosures open and closed
 *
 * The snippet that loads this is rendered by every rp-* section, so the whole
 * file guards against running twice.
 */
(function () {
  if (window.rpRitualLoaded) return;
  window.rpRitualLoaded = true;

  var EASING = 'cubic-bezier(0.25, 0.6, 0.3, 1)';

  function prefersReduced() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* ---------------------------------------------------------------- fade-up */

  function initFade(scope) {
    var els = scope.querySelectorAll('.rp-fade:not(.rp-fade--in)');
    if (!els.length) return;

    function reveal(el) {
      el.classList.add('rp-fade--in');
    }

    if (prefersReduced() || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(els, function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------ animated <details>
   *
   * A native <details> snaps. To animate it we take over the summary click,
   * keep the element open for the whole of a close so the content stays in the
   * box while it shrinks, and animate the element's own height between the
   * summary height and the summary-plus-body height.
   *
   * Everything degrades safely: with reduced motion, or if this script never
   * runs, the disclosures still open and close natively.
   */

  function initDetails(scope) {
    var items = scope.querySelectorAll('details.rp-anim');

    Array.prototype.forEach.call(items, function (el) {
      if (el.dataset.rpAnimBound) return;
      el.dataset.rpAnimBound = '1';

      var summary = el.querySelector('summary');
      var body = el.querySelector('.rp-anim__body');
      if (!summary || !body) return;

      var animation = null;
      var closing = false;

      summary.addEventListener('click', function (event) {
        if (prefersReduced()) return; // let the browser do its native toggle
        event.preventDefault();
        if (closing || !el.open) expand();
        else collapse();
      });

      function openHeight() {
        return summary.offsetHeight + body.offsetHeight;
      }

      function duration(delta) {
        // Long answers take a little longer, but never long enough to drag.
        return Math.min(460, Math.max(200, Math.abs(delta) * 0.55));
      }

      function run(from, to, onFinish) {
        if (animation) animation.cancel();
        animation = el.animate(
          { height: [from + 'px', to + 'px'] },
          { duration: duration(to - from), easing: EASING }
        );
        animation.onfinish = function () {
          if (onFinish) onFinish();
          settle();
        };
        animation.oncancel = settle;
      }

      function settle() {
        animation = null;
        closing = false;
        el.style.height = '';
        el.removeAttribute('data-rp-animating');
        el.removeAttribute('data-rp-closing');
      }

      function expand() {
        closing = false;
        el.removeAttribute('data-rp-closing');
        el.setAttribute('data-rp-animating', '');
        var from = el.offsetHeight;
        el.style.height = from + 'px';
        el.open = true;
        window.requestAnimationFrame(function () {
          run(from, openHeight(), null);
        });
      }

      function collapse() {
        closing = true;
        // Flips the marker back to a plus straight away, rather than waiting
        // for the animation to finish and `open` to actually clear.
        el.setAttribute('data-rp-closing', '');
        el.setAttribute('data-rp-animating', '');
        run(el.offsetHeight, summary.offsetHeight, function () {
          el.open = false;
        });
      }
    });
  }

  /* -------------------------------------------------------------------- run */

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initFade(scope);
    initDetails(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: sections are re-rendered without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
